<template>
  <WCSinglePageForm>
    <template v-slot:title>
      {{ $t('resetPassword') }}
    </template>

    <template v-slot:title-right>
      <label>
        {{ $t('knowYourPassword') }}
        <router-link class="font-weight-bold underline-link-from-center" tabindex="0" to="/login">
          {{ $t('signIn') }}</router-link
        >
      </label>
    </template>

    <template v-slot:subheading>
      {{ $t('weNeedToSendVerificationCode') }}
    </template>

    <template v-slot:body>
      <form @submit.prevent="$emit('submit', form)">
        <WCFormGroup>
          <label for="wc-forgot__reset-method"
            >{{ $t('resetMethod') }}
            <span class="text-danger">*</span>
          </label>
          <WCSelect
            id="wc-forgot__reset-method"
            v-model="$v.form.resetMethod.$model"
            tabindex="1"
            :state="$v.form.resetMethod.$error ? 'invalid' : null"
          >
            <option value="">{{ $t('makeASelection') }}</option>
            <option value="CALL">{{ $t('call') }}</option>
            <option value="EMAIL">{{ $t('email') }}</option>
            <option value="TEXT">{{ $t('text') }}</option>
          </WCSelect>
          <WCValidationErrors :validation="$v.form.resetMethod" />
        </WCFormGroup>

        <WCFormGroup v-if="$v.form.resetMethod.$model === 'EMAIL'">
          <label for="wc-forgot__email"
            >{{ $t('email') }}
            <span class="text-danger">*</span>
          </label>
          <WCInput
            id="wc-forgot__email"
            tabindex="2"
            v-model="$v.form.email.$model"
            :state="$v.form.email.$error ? 'invalid' : null"
          />
          <WCValidationErrors :validation="$v.form.email" />
        </WCFormGroup>

        <WCFormGroup
          v-if="$v.form.resetMethod.$model === 'TEXT' || $v.form.resetMethod.$model === 'CALL'"
        >
          <label for="wc-forgot__phone"
            >{{ $t('phoneNumber') }}
            <span class="text-danger">*</span>
          </label>
          <WCInput
            id="wc-forgot__phone"
            tabindex="3"
            v-model="$v.form.phone.$model"
            :state="$v.form.phone.$error ? 'invalid' : null"
            @input="changePhoneNumberFormat(form.phone)"
          />
          <WCValidationErrors :validation="$v.form.phone" />
        </WCFormGroup>

        <button type="submit" class="btn btn-primary btn-block" :disabled="disabled">
          {{ $t('submit') }}
        </button>
      </form>
    </template>
  </WCSinglePageForm>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { phone } from '@/utils/validators/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCSelect from '@/modules/forms/components/WCSelect/WCSelect.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import WCSinglePageForm from '@/modules/forms/components/WCSinglePageForm/WCSinglePageForm.vue';
import PhoneNumberFormatMixin from '@/mixins/PhoneNumberFormatMixin';

export default {
  components: { WCFormGroup, WCInput, WCValidationErrors, WCSelect, WCSinglePageForm },
  data() {
    return {
      form: {
        resetMethod: '',
        email: '',
        phone: '',
      },
    };
  },
  validations: {
    form: {
      resetMethod: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        phone,
      },
    },
  },
  mixins: [PhoneNumberFormatMixin],
  computed: {
    disabled() {
      const emailCheck = this.$v.form.email.$invalid || this.$v.form.resetMethod.$invalid;
      const phoneCheck = this.$v.form.phone.$invalid || this.$v.form.resetMethod.$invalid;
      return this.$v.form.resetMethod.$model === 'EMAIL' ? emailCheck : phoneCheck;
    },
  },
  methods: {
    /**
     * Method to format the phone number
     * Uses PhoneNumberFormatMixin
     */
    changePhoneNumberFormat(phoneNumber) {
      this.form.phone = this.formatPhoneNumber(phoneNumber);
    },
  },
};
</script>

<style lang="scss" scoped></style>
